import React, { useState, useEffect } from "react";
import {
    Drawer,
    Container,
    IconButton,
    Typography,
    Grid,
    AppBar,
    Button,
    TextField,
    MenuItem,
    MuiThemeProvider
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import SearchIcon from "@material-ui/icons/Search";
import { useDispatch, useSelector } from "react-redux";

import Input from "../../../../Components/Inputs/Input";
import InputMask from "../../../../Components/Inputs/InputMask";

import { setOpenBuscaAvancada, setParamsFilterRelacoesPrevidenciarias } from "../../../../Store/Actions/Reducer/seguradoActions";
import temaFormulario from "../../../../Styles/Temas/temaFormulario";

const drawerWidth = 560;

export default function BuscaAvancada() {

    const { paramsFiltroRelacoesPrevidenciarias, openBuscaAvancada } = useSelector((state) => state.segurado);
    const [filtro, setFiltro] = useState({ cnpj: null, origemVinculo: null, tipoVinculo: null });
    const dispatch = useDispatch();

    useEffect(() => {
        setFiltro({ ...filtro, ...paramsFiltroRelacoesPrevidenciarias });
    }, [paramsFiltroRelacoesPrevidenciarias]); // eslint-disable-line

    const onChangeFiltro = (prop, value) => {
        setFiltro({ ...filtro, [`${prop}`]: value });
    }

    const fecharBuscaAvancada = () => {
        dispatch(setOpenBuscaAvancada());
        setFiltro({ ...paramsFiltroRelacoesPrevidenciarias });
    }

    function buscar() {
        if(filtro.cnpj || filtro.origemVinculo || filtro.tipoVinculo){
            dispatch(setParamsFilterRelacoesPrevidenciarias({ ...paramsFiltroRelacoesPrevidenciarias, ...filtro, pagina: 0, itensPorPagina: 20 }));
            fecharBuscaAvancada();
        }
    }   

    const limparFiltro = () => {
        dispatch(setParamsFilterRelacoesPrevidenciarias(null, true));
        setFiltro({ cnpj: null, origemVinculo: null, tipoVinculo: null });
    }

    return (
        <React.Fragment key={1}>
            <MuiThemeProvider theme={temaFormulario}>
                <Drawer disableRestoreFocus={true}  anchor={"right"} open={openBuscaAvancada} onClose={fecharBuscaAvancada}>
                    <AppBar position="static" elevation={0} style={{ width: `${drawerWidth}px` }}>
                        <Container>
                            <Grid
                                container
                                direction="row"
                                justifyContent="space-between"
                                alignItems="center"
                            >
                                <Grid item>
                                    <Typography  style={{fontWeight: 700}}>Filtrar Vínculos</Typography>
                                </Grid>
                                <Grid item>
                                    <IconButton aria-label="open drawer" onClick={fecharBuscaAvancada}>
                                        <CloseIcon />
                                    </IconButton>
                                </Grid>
                            </Grid>
                        </Container>
                    </AppBar>

                    <br />
                    <br />

                    <Container>
                        <Grid container>
                            <Grid item xs={12}>
                                <Input
                                    id="input_empresa"
                                    label="Empresa"
                                    variant="outlined"
                                    color='secondary'
                                    size='small'
                                    value={filtro['origemVinculo'] ?? ''}
                                    setValue={(e) => onChangeFiltro('origemVinculo', e.target.value)}
                                    maxLength={255}
                                />
                            </Grid>
                        </Grid>
                        <br />
                        <br />
                        <Grid container spacing={4}>
                            <Grid item xs={6}>
                                <InputMask
                                    id="input_cnpj"
                                    label="CNPJ"
                                    variant="outlined"
                                    size='small'
                                    color='secondary'
                                    mask="99.999.999/9999-99"
                                    placeholder="__.___.___/____-__"
                                    value={filtro['cnpj'] ?? ''}
                                    setValue={(e) => onChangeFiltro('cnpj', e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    select
                                    id="select_tipoVinculo"
                                    label={"Tipo de vínculo"}
                                    color='secondary'
                                    variant="outlined"
                                    fullWidth
                                    size='small'
                                    value={filtro['tipoVinculo'] ?? ''}
                                    InputLabelProps={{ shrink: true }}                                    
                                    onChange={(e) => onChangeFiltro('tipoVinculo', e.target.value)}                                    
                                    SelectProps={{
                                        MenuProps: {
                                            anchorOrigin: {
                                                vertical: "bottom",
                                                horizontal: "left"
                                            },
                                            transformOrigin: {
                                                vertical: "top",
                                                horizontal: "left"
                                            },
                                            getContentAnchorEl: null
                                        }
                                    }}
                                >
                                    <MenuItem style={{ minHeight: 30 }} value={""}></MenuItem>
                                    <MenuItem value={"Empregado"}>Empregado</MenuItem>
                                    <MenuItem value={"Contribuinte Individual"}>Contribuinte Individual</MenuItem>
                                    <MenuItem value={"Empresário/Empregador"}>Empresário/Empregador</MenuItem>
                                    <MenuItem value={"Trabalhador Avulso"}>Trabalhador Avulso</MenuItem>
                                    <MenuItem value={"Empregado Doméstico"}>Empregado Doméstico</MenuItem>
                                </TextField>
                            </Grid>
                        </Grid>

                        <br />
                        <br />
                    </Container>

                    <Container
                        style={{
                            width: `${drawerWidth}px`,
                            position: "fixed",
                            bottom: 20,
                            display: "flex",
                            alignContent: "center",
                            justifyContent: "flex-end",
                            flexDirection: "row",
                            alignItems: "center",
                        }}
                    >
                        <Button
                            id="button_limpar_filtro"
                            variant="outlined"                            
                            onClick={limparFiltro}
                            style={{ marginRight: "20px" }}
                        >
                            LIMPAR
                        </Button>
                        <Button
                            id="button_filtrar"
                            variant="contained"
                            color="primary"
                            onClick={buscar}
                            disableElevation
                            startIcon={<SearchIcon />}
                        >
                            FILTRAR
                        </Button>
                    </Container>
                </Drawer>
            </MuiThemeProvider>
        </React.Fragment>
    );

}
